import { UnorderedListOutlined, NotificationOutlined, RiseOutlined, FileOutlined, BankOutlined, ProfileOutlined, TeamOutlined, UserOutlined, FileDoneOutlined, VideoCameraOutlined, AuditOutlined, HighlightOutlined, EditOutlined, ProjectOutlined, ThunderboltOutlined, DashboardOutlined, CalendarOutlined, BarChartOutlined, CameraOutlined, PictureOutlined, SolutionOutlined } from '@ant-design/icons';
import { PERMISSIONS } from '../components/Permissions/utils/permissions';

// the sales secretary panel: its role and the admins, with any of the sales menus
const SECRETARY_ROLES = ['OPERATION_MANAGER', 'ADMIN', 'SUPER_ADMIN'];
const SECRETARY_PERMISSION = [PERMISSIONS.ADVERTISER_MENU, PERMISSIONS.NEGOTIATION_MENU, PERMISSIONS.ORDER_MENU];
export const publicRoutes = [
  {
    path: "/login",
    component: "./pages/Login/Login.react"
  },
  {
    path: "/logout",
    component: "./pages/Login/Login.react"
  },
  {
    path: "/user/confirm/:confirmationToken",
    component: "./pages/Signup/Signup.react"
  },
  {
    path: '/forgot-password',
    component: './pages/Login/ForgotPassword.react'
  },
  {
    path: "/change-password",
    component: "./pages/Login/ChangePassword.react"
  },
  {
    path: "/resource/:resourceType/:resourceId/token/:token/view",
    component: "./components/Share/ShareViewer"
  },
  {
    // the report of an order campaign, opened by the customer from a shared link
    path: "/report/campagna/:token",
    component: "./pages/CampaignReport/CampaignReportPage"
  }
];

export const privateRoutes = [
  {
    name: 'GESTIONE',
    path: '/management',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
    // not in the menu of these roles (the pages stay reachable, e.g. a system opened from Disponibilità)
    hiddenForRoles: ['OPERATION_MANAGER'],
    routes: [
      {
        name: <><DashboardOutlined /> Panoramica</>,
        path: '/management/dashboard',
        component: './pages/Dashboard/Dashboard',
        permission: PERMISSIONS.SYSTEM_MENU,
      },
      {
        name: <><BankOutlined /> Impianti</>,
        path: '/management/systems',
        component: './pages/SystemsManager/SystemsManager',
        permission: PERMISSIONS.SYSTEM_MENU,
        disabled: false
      },
      {
        name: <><PictureOutlined /> Foto impianti</>,
        path: '/management/photos',
        component: './pages/SystemPhotos/SystemPhotos',
        permission: PERMISSIONS.SYSTEM_MENU,
      },
      {
        name: <><EditOutlined /> Formati</>,
        path: '/management/systems/types',
        component: './pages/SystemTypes/SystemTypes',
        permission: PERMISSIONS.SYSTEM_MENU,
        disabled: false
      },
      {
        name: <><TeamOutlined /> Squadre</>,
        path: '/management/teamManagement',
        component: './pages/TeamManagement/TeamManagementManager',
        permission: PERMISSIONS.TEAM_MENU,
      },
      {
        name: <><AuditOutlined /> Verifiche</>,
        path: '/management/audits',
        component: './pages/AuditManager/AuditManager',
        permission: PERMISSIONS.SYSTEM_VERIFICHE,
      },
      {
        name: <><ThunderboltOutlined /> Punti Luce</>,
        path: '/management/energy',
        component: './pages/EnergyManager/EnergyManager',
        permission: PERMISSIONS.SYSTEM_MENU,
      },
      {
        name: <><FileDoneOutlined /> Adempimenti</>,
        path: '/management/licenses',
        component: './pages/Licenses/LicensesManager',
        permission: PERMISSIONS.LICENSE_MENU,
      },
      {
        name: <><ProjectOutlined /> Progetti</>,
        path: '/management/compliance',
        component: './pages/Compliances/ComplianceManager',
        permission: PERMISSIONS.LICENSE_MENU,
      },
    ]
  },

  {
    path: "/select-tenant",
    component: "./pages/Login/SelectTenant.react",
    permission: PERMISSIONS.USER_READ,
  },

  {
    path: '/',
    component: './pages/Dashboard/Dashboard',
    permission: PERMISSIONS.SYSTEM_MENU,
  },

  {
    path: '/management/dashboard',
    component: './pages/Dashboard/Dashboard',
    permission: PERMISSIONS.SYSTEM_MENU,
  },

  // Systems
  {
    path: '/management/systems/map',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems/types',
    component: './pages/SystemTypes/SystemTypes',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    // the new layout of the systems list, side by side with the current one until it replaces it
    path: '/management/systems-new',
    component: './pages/SystemsManagerNew/SystemsManagerNew',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/photos',
    component: './pages/SystemPhotos/SystemPhotos',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems/new',
    component: './pages/SystemsManager/SystemFormPage',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems/:id',
    component: './pages/SystemsManager/Systems.Detail',
    permission: PERMISSIONS.SYSTEM_READ,
  },

  // Teams
  {
    path: '/management/teamManagement',
    component: './pages/TeamManagement/TeamManagementManager',
    permission: PERMISSIONS.TEAM_MENU,
  },

  // Audits
  {
    path: '/management/audits',
    component: './pages/AuditManager/AuditManager',
    permission: PERMISSIONS.SYSTEM_VERIFICHE,
  },

  // Energy
  {
    path: '/management/energy',
    component: './pages/EnergyManager/EnergyManager',
    permission: PERMISSIONS.SYSTEM_MENU,
  },

  // Licenses
  {
    path: '/management/licenses',
    component: './pages/Licenses/LicensesManager',
    permission: PERMISSIONS.LICENSE_MENU,
  },
  {
    path: '/management/licenses/:id',
    component: './pages/Licenses/LicenseDetail',
    permission: PERMISSIONS.LICENSE_READ,
  },

  // Compliance
  {
    path: '/management/compliance',
    component: './pages/Compliances/ComplianceManager',
    permission: PERMISSIONS.LICENSE_MENU,
  },

  // SALES
  {
    name: 'VENDITE',
    path: '/sales',
    component: './pages/Negotiations/NegotiationsManager',
    permission: PERMISSIONS.NEGOTIATION_MENU,
    routes: [
      { name: <><SolutionOutlined /> Segreteria</>, path: '/sales/secretary', permission: SECRETARY_PERMISSION, roles: SECRETARY_ROLES, disabled: false },
      { name: <><UserOutlined /> Inserzionisti</>, path: '/sales/advertisers', permission: PERMISSIONS.ADVERTISER_MENU, disabled: false },
      { name: <><FileOutlined /> Trattative </>, path: '/sales/negotiations', permission: PERMISSIONS.NEGOTIATION_MENU, disabled: false },
      { name: <>< ProfileOutlined /> Ordini</>, path: '/sales/orders', permission: PERMISSIONS.ORDER_MENU, disabled: false },
      { name: <><CalendarOutlined /> Disponibilità</>, path: '/sales/availability', permission: PERMISSIONS.NEGOTIATION_MENU, disabled: false },
      { name: <><BarChartOutlined /> Occupazione</>, path: '/sales/occupancy', permission: PERMISSIONS.NEGOTIATION_MENU, disabled: false },
      { name: <><RiseOutlined /> Dashboard Funnel</>, path: '/sales/dashboardAnalytics', permission: PERMISSIONS.ANALYTICS_MENU, disabled: false },
    ]
  },

  // Sales secretary workspace
  {
    path: '/sales/secretary',
    component: './pages/Secretary/SecretaryDashboard',
    permission: SECRETARY_PERMISSION,
    roles: SECRETARY_ROLES,
  },

  // REPORT: Superset dashboards embedded (guest token from the advertiser service), same roles as the secretary
  {
    name: 'REPORT',
    path: '/reports',
    component: './pages/Reports/ReportPage',
    permission: SECRETARY_PERMISSION,
    roles: SECRETARY_ROLES,
    routes: [
      { name: <><BarChartOutlined /> CRM: lead e contatti</>, path: '/reports/crm', permission: SECRETARY_PERMISSION, roles: SECRETARY_ROLES, disabled: false },
    ]
  },
  {
    path: '/reports/:report',
    component: './pages/Reports/ReportPage',
    permission: SECRETARY_PERMISSION,
    roles: SECRETARY_ROLES,
  },

  // Advertisers
  {
    path: '/sales/advertisers',
    component: './pages/Advertisers/AdvertiserPage',
    permission: PERMISSIONS.ADVERTISER_MENU,
  },
  {
    path: '/sales/advertisers/:id',
    component: './pages/Advertisers/AdvertiserDetailPage',
    permission: PERMISSIONS.ADVERTISER_READ,
  },

  // Negotiations
  {
    path: '/sales/negotiations',
    component: './pages/Negotiations/NegotiationsManager',
    permission: PERMISSIONS.NEGOTIATION_MENU,
  },
  {
    path: '/sales/negotiations/:id',
    component: './pages/Negotiations/NegotiationsDetail',
    permission: PERMISSIONS.NEGOTIATION_READ,
  },

  // Quotes
  {
    path: "/sales/quote/:id/view",
    component: "./pages/Quotes/QuoteDetail.jsx",
    permission: PERMISSIONS.QUOTE_READ,
  },
  {
    path: "/sales/quote/:id/edit",
    component: "./pages/Quotes/QuoteDetail.jsx",
    permission: PERMISSIONS.QUOTE_READ,
  },

  // Orders
  {
    path: "/sales/orders",
    component: "./pages/Orders/OrdersManager.jsx",
    permission: PERMISSIONS.ORDER_MENU,
  },
  {
    path: "/sales/orders/:id",
    component: "./pages/Orders/OrderDetail.jsx",
    permission: PERMISSIONS.ORDER_READ,
  },

  // Occupancy
  {
    path: '/sales/occupancy',
    component: './pages/Occupancy/OccupancyManager',
    permission: PERMISSIONS.NEGOTIATION_MENU,
  },

  // Availability
  {
    path: '/sales/availability',
    component: './pages/Availability/AvailabilityManager',
    permission: PERMISSIONS.NEGOTIATION_MENU,
  },

  {
    path: '/sales/dashboardAnalytics',
    component: './pages/Analytics/DashboardAnalytics',
    permission: PERMISSIONS.ANALYTICS_MENU,
  },

  // DELIVERY
  {
    name: 'DISTRIBUZIONE',
    path: '/delivery',
    component: './pages/Plannings/PlanningsManager',
    permission: PERMISSIONS.PLANNING_MENU,
    routes: [
      { name: <><UnorderedListOutlined /> Pianificazioni</>, path: '/delivery/plannings', permission: PERMISSIONS.PLANNING_MENU, disabled: false },
      { name: <><NotificationOutlined /> Campagne </>, path: '/delivery/campaigns', permission: PERMISSIONS.CAMPAIGN_MENU, disabled: false },
      { name: <><VideoCameraOutlined /> Espletamento</>, path: '/delivery/posting', disabled: false, permission: [PERMISSIONS.POSTING_MENU, PERMISSIONS.PLANNING_MENU] },
      { name: <><CameraOutlined /> Le mie affissioni</>, path: '/delivery/posting/squad', disabled: false, permission: [PERMISSIONS.POSTING_SQUAD, PERMISSIONS.PLANNING_MENU] },
      { name: <><PictureOutlined /> Report fotografici</>, path: '/delivery/posting/reports', disabled: false, permission: [PERMISSIONS.POSTING_REPORT, PERMISSIONS.PLANNING_MENU] },
    ]
  },

  {
    path: '/delivery/plannings',
    component: './pages/Plannings/PlanningsManager',
    permission: PERMISSIONS.PLANNING_MENU,
  },
  {
    path: '/delivery/plannings/:id',
    component: './pages/Plannings/PlanningDetail',
    permission: PERMISSIONS.PLANNING_READ,
  },
  {
    path: '/delivery/plannings/:id/search',
    component: './pages/Plannings/PlanningDetail',
    permission: PERMISSIONS.PLANNING_READ,
  },

  // Espletamento (posting), replacing Appeso. planning.menu keeps access until the roles get the posting permissions
  {
    path: '/delivery/posting',
    component: './pages/Posting/PostingManager',
    permission: [PERMISSIONS.POSTING_MENU, PERMISSIONS.PLANNING_MENU],
  },
  {
    path: '/delivery/posting/reports',
    component: './pages/Posting/PostingReports',
    permission: [PERMISSIONS.POSTING_REPORT, PERMISSIONS.PLANNING_MENU],
  },
  {
    path: '/delivery/posting/squad',
    component: './pages/Posting/PostingSquad',
    permission: [PERMISSIONS.POSTING_SQUAD, PERMISSIONS.PLANNING_MENU],
  },
  {
    path: '/delivery/posting/orders/:id',
    component: './pages/Posting/PostingOrderDetail',
    permission: [PERMISSIONS.POSTING_MENU, PERMISSIONS.PLANNING_MENU],
  },

  {
    path: '/delivery/campaigns',
    component: './pages/Campaigns/CampaignsManager',
    permission: PERMISSIONS.CAMPAIGN_MENU,
  },
  {
    path: '/delivery/campaigns/:id',
    component: './pages/Campaigns/CampaignDetail',
    permission: PERMISSIONS.CAMPAIGN_READ,
  },

  {
    path: '/delivery/DOOHanalytics',
    component: './pages/Analytics/DOOHAnalytics',
    //permission: PERMISSIONS.ANALYTICS_ALL,
  },

  // MEDIA MONITOR
  {
    name: 'MEDIA MONITOR',
    path: '/media-monitor',
    component: './pages/MediaMonitor/MediaMonitor',
    routes: [
      { name: <><AuditOutlined /> Rilevazioni</>, path: '/media-monitor/monitor', disabled: false, permission: PERMISSIONS.DETECTION_MENU },
      { name: <><RiseOutlined /> Riepilogo</>, path: '/media-monitor/analytics', key: 'mediamonitor-analytics', disabled: false, permission: PERMISSIONS.DETECTION_MENU },
      {
        name: <><HighlightOutlined /> Gestione Campi</>, path: '/media-monitor/manage', disabled: false, permission: PERMISSIONS.DETECTION_MENU,
      },
    ],
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/media-monitor/monitor',
    component: './pages/MediaMonitor/MediaMonitor',
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/media-monitor/analytics',
    component: './pages/Analytics/MediaAnalytics',
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/media-monitor/manage',
    component: './pages/MediaMonitor/MediaMonitorManageFields',
    permission: PERMISSIONS.DETECTION_AGENT_ALL,
  },


  // OTHER
  {
    path: '/dooh-manage/manage',
    component: './pages/DoohManager/DoohManager',
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/shows-manage/manage',
    component: './pages/ShowsManager/ShowsManager',
    //permission: PERMISSIONS.SHOWS_ALL,
  },
  {
    path: '/dooh/players',
    component: './pages/Dooh/Players',
    //permission: PERMISSIONS.PLAYERS_ALL,
  },
  {
    path: '/playerDOOH',
    component: './pages/Shows/ShowManager',
    //permission: PERMISSIONS.SHOWS_ALL,
  },
  {
    path: '/settings/users',
    component: './pages/Settings/UsersSettings',
    permission: PERMISSIONS.USER_ALL,
  },
  {
    path: "/profile",
    component: "./pages/Profile/Profile.jsx",
    permission: PERMISSIONS.USER_READ,
  },
  {
    path: "/test",
    component: "./pages/Test.jsx",
    permission: PERMISSIONS.TEST_ALL,
  },
];